import { DatetimeModal } from "../common/datetime-modal";

export class UpdateAccessCompanyModel {
  public companySurrKey: number;
  public status: boolean;
  public expireDate: DatetimeModal;
}
